/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Resource information
 * @export
 * @interface TravelineResourceDto
 */
export interface TravelineResourceDto {
    /**
     * Resource link
     * @type {string}
     * @memberof TravelineResourceDto
     */
    url: string;
}

/**
 * Check if a given object implements the TravelineResourceDto interface.
 */
export function instanceOfTravelineResourceDto(value: object): value is TravelineResourceDto {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function TravelineResourceDtoFromJSON(json: any): TravelineResourceDto {
    return TravelineResourceDtoFromJSONTyped(json, false);
}

export function TravelineResourceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineResourceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

  export function TravelineResourceDtoToJSON(json: any): TravelineResourceDto {
      return TravelineResourceDtoToJSONTyped(json, false);
  }

  export function TravelineResourceDtoToJSONTyped(value?: TravelineResourceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

